import { ErrorResponseData, PropType } from '../../types/types'

export class HttpResponseError extends Error {
  constructor(
    public response: Response,
    message = '',
    public data: PropType<ErrorResponseData, 'error'> | null = null,
  ) {
    super(message)
  }
}
